// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import type { JsonValueType } from '../inputTypeSchemas/JsonValueSchema';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { DynamicApplicationScanRunSchema } from './DynamicApplicationScanRunSchema';

/////////////////////////////////////////
// DYNAMIC APPLICATION SCAN RUN RELATION SCHEMA
/////////////////////////////////////////

export type DynamicApplicationScanRunRelations = {
  application: ApplicationWithRelations;
};

export type DynamicApplicationScanRunWithRelations = Omit<z.infer<typeof DynamicApplicationScanRunSchema>, "scanTargets"> & {
  scanTargets?: JsonValueType | null;
} & DynamicApplicationScanRunRelations

export const DynamicApplicationScanRunWithRelationsSchema: z.ZodType<DynamicApplicationScanRunWithRelations> = DynamicApplicationScanRunSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
}))